<mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChanged($event)"
  animationDuration="0ms">

  <!-- ==================== TAB 1: INVENTORY ==================== -->
  <mat-tab>
    <ng-template mat-tab-label>
      <i-tabler name="packages" class="icon-18 m-r-8"></i-tabler>
      {{ 'PHARMACY.INVENTORY' | translate }}
    </ng-template>
    <div class="p-t-16">
      <!-- Search + Add Button -->
      <div class="row d-flex justify-content-between align-items-center m-b-10 flex-wrap gap-8 m-r-0">
        <div class="col-lg-4">
          <mat-form-field appearance="outline" class="w-100 hide-hint">
            <input matInput placeholder="{{ 'PHARMACY.SEARCH_INVENTORY' | translate }}"
              [formControl]="inventorySearchCtrl">
            <mat-icon matSuffix>
              <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
            </mat-icon>
          </mat-form-field>
        </div>
        <div class="col-lg-4 d-flex align-items-center justify-content-end">
          <button mat-flat-button color="primary" (click)="onAddInventory()">
            <mat-icon>add</mat-icon>
            {{ 'PHARMACY.ADD_TO_INVENTORY' | translate }}
          </button>
        </div>
      </div>
      <!-- Inventory Table -->
      <mat-card class="cardWithShadow overflow-hidden">
        <mat-card-content class="p-0">
          <div class="table-responsive table-scroll-container">
            <table mat-table [dataSource]="inventoryDataSource" class="w-100">

              <ng-container matColumnDef="drugName">
                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                  {{ 'PHARMACY.DRUG_NAME' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="f-s-14">
                  {{ element.drugName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="drugTypeName">
                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                  {{ 'PHARMACY.TYPE' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="f-s-14">
                  {{ element.drugTypeName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="sellingPrice">
                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                  {{ 'PHARMACY.MRP' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="f-s-14">
                  {{ element.sellingPrice | indianCurrency }}
                </td>
              </ng-container>

              <ng-container matColumnDef="gstPercentage">
                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                  {{ 'PHARMACY.GST_PERCENT' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="f-s-14">
                  {{ element.gstPercentage }}%
                </td>
              </ng-container>

              <ng-container matColumnDef="totalStock">
                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                  {{ 'PHARMACY.TOTAL_STOCK' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="f-s-14" [ngClass]="{ 'text-warn': element.isLowStock }">
                  {{ element.totalStock }}
                  <i-tabler *ngIf="element.isLowStock" name="alert-triangle" class="icon-14 text-warn m-l-4"></i-tabler>
                </td>
              </ng-container>

              <ng-container matColumnDef="reorderLevel">
                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                  {{ 'PHARMACY.REORDER_LEVEL' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="f-s-14">
                  {{ element.reorderLevel }}
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                  {{ 'LABEL.ACTION_LABEL' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="action-link">
                  <a class="m-r-10 cursor-pointer" (click)="onEditInventory(element)"
                    matTooltip="{{ 'LABEL.EDIT' | translate }}">
                    <i-tabler name="edit" class="icon-18"></i-tabler>
                  </a>
                  <a class="m-r-10 cursor-pointer" (click)="onAddBatch(element)"
                    matTooltip="{{ 'PHARMACY.ADD_BATCH' | translate }}">
                    <i-tabler name="package-import" class="icon-18"></i-tabler>
                  </a>
                  <a class="cursor-pointer" (click)="onViewBatches(element)"
                    matTooltip="{{ 'PHARMACY.VIEW_BATCHES' | translate }}">
                    <i-tabler name="eye" class="icon-18"></i-tabler>
                  </a>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="inventoryDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: inventoryDisplayedColumns"></tr>
            </table>

            <div *ngIf="inventoryDataSource.data.length === 0">
              <p class="text-center f-s-20 f-w-700 m-t-20">{{ 'LABEL.NO_DATA' | translate }}</p>
            </div>

            <mat-paginator #inventoryPaginator class="paginator-fixed" *ngIf="inventoryPagination"
              [ngClass]="{ 'pointer-events-none': isInventoryLoading }" [length]="inventoryCount"
              [pageSize]="inventoryPagination.pageSize || 20" [pageSizeOptions]="pageSizeOptions"
              [showFirstLastButtons]="true" [pageIndex]="inventoryPagination.currentPage || 0"
              (page)="onInventoryPageChange($event)">
            </mat-paginator>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-tab>

  <!-- ==================== TAB 2: STOCK IN (List) ==================== -->
  <mat-tab>
    <ng-template mat-tab-label>
      <i-tabler name="package-import" class="icon-18 m-r-8"></i-tabler>
      {{ 'PHARMACY.STOCK_IN' | translate }}
    </ng-template>
    <div class="p-t-16">
      <!-- Filter Row -->
      <div class="filter-row">
        <div class="filter-controls">
          <mat-form-field appearance="outline" class="filter-field hide-hint">
            <mat-label>{{ 'LABEL.SEARCH_LABEL' | translate }}</mat-label>
            <input matInput [formControl]="stockInSearchCtrl" />
            <mat-icon matSuffix>
              <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
            </mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field hide-hint">
            <mat-label>{{ 'LABEL.DATE_RANGE' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="stockInRangePicker" [max]="maxDate">
              <input matStartDate [formControl]="stockInStartDate" readonly>
              <input matEndDate [formControl]="stockInEndDate" readonly>
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="stockInRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #stockInRangePicker color="primary"></mat-date-range-picker>
          </mat-form-field>

          <button mat-flat-button color="primary" (click)="loadStockInList()">
            {{ 'LABEL.SEARCH_LABEL' | translate }}
          </button>
          <button mat-stroked-button (click)="clearStockInFilters()">
            {{ 'LABEL.CLEAR' | translate }}
          </button>
        </div>

        <button mat-flat-button color="primary" (click)="openStockInDialog()">
          <mat-icon>add</mat-icon>
          {{ 'PHARMACY.NEW_STOCK_IN' | translate }}
        </button>
      </div>

      <!-- Stock In List Table -->
      <mat-card class="cardWithShadow overflow-hidden">
        <mat-card-content>
          @if (isStockInLoading) {
          <div class="d-flex justify-content-center p-y-24">
            <mat-spinner diameter="36"></mat-spinner>
          </div>
          } @else if (stockInDataSource.filteredData.length === 0) {
          <div class="text-center p-y-24">
            <p class="text-center f-s-20 f-w-700 m-t-20">{{'LABEL.NO_DATA' | translate}}</p>
          </div>
          } @else {
          <div class="table-responsive table-scroll-container">
            <table mat-table [dataSource]="stockInDataSource" class="w-100">

              <ng-container matColumnDef="createdOn">
                <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.DATE' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.createdOn | date:'dd/MM/yyyy' }}</td>
              </ng-container>

              <ng-container matColumnDef="reference">
                <th mat-header-cell *matHeaderCellDef>{{ 'PHARMACY.REFERENCE_INVOICE' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.reference || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="drugName">
                <th mat-header-cell *matHeaderCellDef>{{ 'PHARMACY.DRUG_NAME' | translate }}</th>
                <td mat-cell *matCellDef="let row">
                  <span class="f-w-600">{{ row.drugName }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="batchNo">
                <th mat-header-cell *matHeaderCellDef>{{ 'PHARMACY.BATCH_NO' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.batchNo }}</td>
              </ng-container>

              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'PHARMACY.QTY' | translate }}</th>
                <td mat-cell *matCellDef="let row" class="text-right">{{ row.quantity }}</td>
              </ng-container>

              <ng-container matColumnDef="purchasePrice">
                <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'PHARMACY.PURCHASE_PRICE' | translate }}
                </th>
                <td mat-cell *matCellDef="let row" class="text-right">
                  {{ row.purchasePrice != null ? (row.purchasePrice | number:'1.2-2') : '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="sellingPrice">
                <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'PHARMACY.SELLING_PRICE_MRP' | translate }}
                </th>
                <td mat-cell *matCellDef="let row" class="text-right">
                  {{ row.sellingPrice != null ? (row.sellingPrice | number:'1.2-2') : '-' }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="stockInDisplayedColumns; sticky: true" class="f-w-700"></tr>
              <tr mat-row *matRowDef="let row; columns: stockInDisplayedColumns;"></tr>
            </table>
          </div>
          }
          <mat-paginator #stockInPaginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isStockInLoading}"
            [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" [pageSize]="10">
          </mat-paginator>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-tab>

  <!-- ==================== TAB 3: DISPENSE (Bill List) ==================== -->
  <mat-tab>
    <ng-template mat-tab-label>
      <i-tabler name="receipt" class="icon-18 m-r-8"></i-tabler>
      {{ 'PHARMACY.DISPENSE' | translate }}
    </ng-template>
    <div class="p-t-16">
      <!-- Filter Row -->
      <div class="filter-row">
        <div class="filter-controls">
          <mat-form-field appearance="outline" class="filter-field hide-hint">
            <mat-label>{{ 'LABEL.SEARCH_LABEL' | translate }}</mat-label>
            <input matInput [formControl]="billSearchCtrl" />
            <mat-icon matSuffix>
              <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
            </mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field hide-hint">
            <mat-label>{{ 'LABEL.DATE_RANGE' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="billRangePicker" [max]="maxDate">
              <input matStartDate [formControl]="billStartDate" readonly>
              <input matEndDate [formControl]="billEndDate" readonly>
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="billRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #billRangePicker color="primary"></mat-date-range-picker>
          </mat-form-field>

          <button mat-flat-button color="primary" (click)="loadBills()">
            {{ 'LABEL.SEARCH_LABEL' | translate }}
          </button>
          <button mat-stroked-button (click)="clearBillFilters()">
            {{ 'LABEL.CLEAR' | translate }}
          </button>
        </div>

        <button mat-flat-button color="primary" (click)="openDispenseDialog('create')">
          <mat-icon>add</mat-icon>
          {{ 'PHARMACY.NEW_DISPENSE' | translate }}
        </button>
      </div>

      <!-- Bill List Table -->
      <mat-card class="cardWithShadow overflow-hidden">
        <mat-card-content>
          @if (isBillsLoading) {
          <div class="d-flex justify-content-center p-y-24">
            <mat-spinner diameter="36"></mat-spinner>
          </div>
          } @else if (billDataSource.filteredData.length === 0) {
          <div class="text-center p-y-24">
            <p class="text-center f-s-20 f-w-700 m-t-20">{{'LABEL.NO_DATA' | translate}}</p>
          </div>
          } @else {
          <div class="table-responsive table-scroll-container">
            <table mat-table [dataSource]="billDataSource" class="w-100">

              <ng-container matColumnDef="patientName">
                <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.PATIENT_NAME' | translate }}</th>
                <td mat-cell *matCellDef="let row">
                  <span class="f-w-600">{{ row.patientName }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="billNo">
                <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.BILL_NO' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.billNo }}</td>
              </ng-container>

              <ng-container matColumnDef="billAmount">
                <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'LABEL.BILL_AMOUNT' | translate }}</th>
                <td mat-cell *matCellDef="let row" class="text-right">{{ row.amount | number:'1.2-2' }}</td>
              </ng-container>

              <ng-container matColumnDef="paidAmount">
                <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'LABEL.PAID_AMOUNT' | translate }}</th>
                <td mat-cell *matCellDef="let row" class="text-right text-paid">{{ row.paidAmount | number:'1.2-2' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="pendingAmount">
                <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'LABEL.PENDING_AMOUNT' | translate }}</th>
                <td mat-cell *matCellDef="let row" class="text-right" [class.text-warn]="row.pendingAmount > 0">
                  {{ row.pendingAmount | number:'1.2-2' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="billDate">
                <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.BILL_DATE' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.billDate | date:'dd/MM/yyyy' }}</td>
              </ng-container>

              <ng-container matColumnDef="paymentStatus">
                <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.PAYMENT_STATUS' | translate }}</th>
                <td mat-cell *matCellDef="let row">
                  <span class="status-badge" [ngClass]="getStatusClass(row.paymentStatus)">
                    {{ getStatusLabel(row.paymentStatus) }}
                  </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="billDisplayedColumns; sticky: true" class="f-w-700"></tr>
              <tr mat-row *matRowDef="let row; columns: billDisplayedColumns;" class="cursor-pointer"
                (click)="openDispenseDialog('view', row.id)">
              </tr>
            </table>
          </div>
          }
          <mat-paginator #billPaginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isBillsLoading}"
            [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" [pageSize]="10">
          </mat-paginator>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-tab>

</mat-tab-group>